import { combineReducers } from 'redux';
// reducers
import notifications from './notifications';
import user from './user';
import classroom from './classroom';
import modalState from './modal';

export default combineReducers({ classroom, user, notifications, modalState });
